/*

Raghu 27/10/2022 3225736869 Card Styling Fixes
Lalitha 10/27/2022 3225736869 night jobs UX changes
Ashraf 12/16/2022 3225736869 fixed role based access

*/
import React from 'react';
import SearchNightJobContainer from './SearchNightJobContainer';

function SearchNightJob({setTabValue, setValue, setBreCode, setNightJobCode, setIsCopyRowData, setJobCode, setSelected}) {
  return (
    <div className={`mb-0`}>
      <SearchNightJobContainer
        setValue={setValue}
        setTabValue={setTabValue}
        setJobCode={setJobCode}
        setBreCode={setBreCode}
        setNightJobCode={setNightJobCode}
        setIsCopyRowData={setIsCopyRowData}
        setSelected={setSelected}
      />
    </div>
  );
}

export default SearchNightJob;
